export default __webpack_public_path__ + "static/media/crypto-farming.40f736eb.png";